import React from 'react'
import '@stretto/cds-tokens/lib/css/base.css'
import './styles.scss'

export interface ChatInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  onSend?: () => void
}

const ChatInput = ({
  onChange,
  onSend,
  placeholder = 'Type a question or add documents',
  ...props
}: ChatInputProps): JSX.Element => {
  return (
    <div className='ChatInputContainer'>
      {/* Empty div to maintain structure, if needed */}
      <input
        className='ChatInput'
        name='chat-input'
        id='chat-input'
        type='text'
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onSend) {
            onSend()
          }
        }}
        placeholder={placeholder}
        {...props}
      />
      <button
        className='ChatInputButton'
        type='button'
        onClick={onSend}
        disabled={!onSend}
      >
        <svg
          className='ChatInputIcon'
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
        >
          <path
            d='M1 18V2L20 10L1 18ZM3 15L14.85 10L3 5V8.5L9 10L3 11.5V15Z'
            fill='#173237'
          />
        </svg>
      </button>
    </div>
  )
}

export default ChatInput
